/**

HSL : (360, 100,100)
RGB: (255,255,255)

**/

let abs = Math.abs,
  round = Math.round;

// a private internal functoin
// function hue2rgb(p, q, t){
//   if(t < 1/6) return p + (q - p) * 6 * t;
//   if(t < 1/2) return q;
//   if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
//   return p;
// }

function hsl2rgb(hsl){
  let r, g, b,
    h = hsl[0] / 360,
    s = hsl[1] / 100,
    l = hsl[2] / 100;
  if(s === 0) {
    r = g = b = l; // achromatic
  } else {
    while(h < 0) h += 1;
    while(h > 1) h -= 1;

    let chroma = ( 1 - abs(2*l - 1)  ) * s;
    let x = chroma * ( 1 - abs((h*6)%2 -1 ));
    let m = l - chroma*.5;
    if ( h < 1/6) {
      r = chroma;
      g = x;
      b = 0;
    } else if ( h < 2/6) {
      r = x;
      g = chroma;
      b = 0;
    } else if ( h < 3/6) {
      r = 0;
      g = chroma;
      b = x;
    } else if ( h < 4/6) {
      r = 0;
      g = x;
      b = chroma;
    } else if ( h < 5/6) {
      r = x;
      g = 0;
      b = chroma;
    } else {
      r = chroma;
      g = 0;
      b = x;
    }
    r += m;
    g += m;
    b += m;

    // var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    // var p = 2 * l - q;
    // console.log('p,q,h', p,q,h)
    // r = hue2rgb(p, q, h + 1/3);
    // g = hue2rgb(p, q, h);
    // b = hue2rgb(p, q, h - 1/3);
  }
  return [ round(r * 255), round(g * 255), round(b * 255)];
}



function rgb2hsl(rgb){
  // scale rgb down to values between 0 and 1
  let red = 1.0 * rgb[0] / 255;
  let green = 1.0 * rgb[1] / 255;
  let blue  = 1.0 * rgb[2] / 255;
  // find which are the greatest and least values

  let min = red < green ? red : green;
  min = min < blue ? min : blue;

  let max = red > green ? red : green;
  max = max > blue ? max : blue;

  let l = 50 * (max + min);
  let h, s;
  if (max === min)
  {
    h = 0;
    s  = 0;
  } else {
    let maxMinDiff = max - min;
    //set saturation
    if (l<=50)
    {
      s  = 100 * maxMinDiff / (max+min);
    }
    else
    {
      s  = 100 * maxMinDiff / (2-max-min);
    }
    // set hue
    if (max === red)
    {
      h  = ( 60 * ( ( green - blue ) / maxMinDiff ) + 360 ) % 360;
    }
    else if (max === green)
    {
      h  = 60 * ( ( blue - red  ) / maxMinDiff ) + 120;
    }
    else if (max === blue)
    {
      h  = 60 * ( ( red  - green  ) / maxMinDiff ) + 240;
    }
  }
  return [h,s,l];
}

/**
* @param c1 and c2: 3 element array of numbers
* @param progress: between 0 and 1
*/

function lerpColor(c1,c2,progress){
  let p = progress < 0 ? 0 : progress > 1 ? 1 : progress;
  return c1.map((c,i)=>c+(c2[i]-c)*p);
}

function getColorFromRGB(r,g,b){
  return `rgb(${round(r)},${round(g)},${round(b)})`;
}

function getColorFromArray(rgb){
  return getColorFromRGB(rgb[0],rgb[1],rgb[2]);
}

function getAlphaColorFromArray(rgba){
  return `rgba(${round(rgba[0])},${round(rgba[1])},${round(rgba[2]) },${rgba[3]})`;
}

function getAlphaColorFromRGB(rgb,a){
  return `rgba(${round(rgb[0])},${round(rgb[1])},${round(rgb[2]) },${a})`;
}


function lerpHSL(c1,c2,progress){
  let p = progress < 0 ? 0 : progress > 1 ? 1 : progress;
  c2 = rgb2hsl(c2);
  return hsl2rgb(rgb2hsl(c1).map((c,i)=>c+(c2[i]-c)*p));
}

function test() {

  function rgb2hslAndBack(rgb) {
    let hsl = rgb2hsl(rgb);
    let backAgain = hsl2rgb(hsl);
    let success = true;
    for ( let i=0,L=backAgain.length;i<L;i++) {
      backAgain[i] = Math.round(backAgain[i]);
      if ( backAgain[i] !== rgb[i]) success = false;
    }
    return success;

    // console.log(rgb, backAgain, success, hsl);
  }

  rgb2hslAndBack([0,0,0]);
  rgb2hslAndBack([255,255,255]);
  rgb2hslAndBack([255,0,0]);
  rgb2hslAndBack([0,255,0]);
  rgb2hslAndBack([0,0,255]);
  rgb2hslAndBack([255,0,1]);
  rgb2hslAndBack([255,255,0]);
  rgb2hslAndBack([255,255,100]);
  rgb2hslAndBack([200,200,200]);
  rgb2hslAndBack([100,100,100]);
  rgb2hslAndBack([0,128,255]);
  rgb2hslAndBack([128,128,255]);
  rgb2hslAndBack([100,150,200]);

}

function getGradient(ctx, x1,x2,stop1,stop2, edgeAlpha){
  try {
    let gradient = ctx.createLinearGradient(x1, 0, x2, 0),
      edgeRgba = `rgba(255,255,255,${  edgeAlpha||0  })`;
    gradient.addColorStop(0, edgeRgba);
    gradient.addColorStop(stop1, 'white');
    gradient.addColorStop(stop2, 'white');
    gradient.addColorStop(1, edgeRgba);
    return gradient;
  } catch(err) {
    // console.log(err);
    // console.log(x1,x2,stop1, stop2);
  }
}






export {
  hsl2rgb, rgb2hsl, lerpColor, lerpHSL,
  getColorFromRGB, getColorFromArray,
  getAlphaColorFromArray, getAlphaColorFromRGB,
  getGradient, test
};
